import React, { useState, useEffect, useRef, Fragment } from 'react';
import Header from '../commons/Header';
import Footer from '../commons/Footer';
import { useHistory, NavLink, Link } from "react-router-dom";
import { PROJECTNAMEALIAS, NFTAPIBASENAME, COLLECTIONIMAGEBASEURL, NFTIMAGEBASEURL } from '../helpers/Setup'
import { showToast, callAPI, showHttpError, checkIfUserIsLoggedIn, getAllSessionData, handleCartManipulation, getBlockChainContract } from '../helpers/Library';
import moment from 'moment';
import Loader from '../commons/Loader';
import Chart from 'chart.js/auto';
import axios from 'axios';
import { ethers } from "ethers";
import web3 from "web3";
import DateTimePicker from 'react-datetime-picker';
import { Line, Bar } from "react-chartjs-2";




const UserCollections = (props) => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [showFloorBidPopup, setFloorBidPopup] = useState(false);
    const [showStatusCategory, setStatusCategory] = useState(false);
    const [showCurrencyCategory, setCurrencyCategory] = useState(false);
    const [isDisplayTab, setDisplayTab] = useState('items');
    const [coverPicture, setCoverPicture] = useState('../assets/images/banner-01.jpg');
    const [collectionImage, setCollectionImage] = useState('../assets/images/images2.jfif');
    const [volumePriceData, setVolumePriceData] = useState({})
    const [volumePriceOptions, setVolumePriceOptions] = useState({})
    const [floorPriceData, setFloorPriceData] = useState({})
    const [floorPriceOptions, setFloorPriceOptions] = useState({})
    const [collectionId, setCollectionId] = useState(null)
    const [collectionName, setCollectionName] = useState('')
    const [collectionDesc, setCollectionDesc] = useState('')
    const [showCreateColBtn, setShowCreateColBtn] = useState(false);

    //state for search nft collecions
    const [orderingType, setOrderingType] = useState(0);
    const [searchString, setSearchString] = useState('');
    const [activeCatItems, setActiveCatItems] = useState('All');
    const [activeCurrencyItem, setActiveCurrencyItem] = useState('ETH')
    const [nftStatus, setNftStatus] = useState('0');
    const [toValue, setToValue] = useState('0');
    const [fromValue, setFromValue] = useState('0');
    const [isPriceFilterInitiated, setPriceFilterIntiated] = useState(false);
    const [nftCollection, setNftCollection] = useState([])
    const [showEditCollModal, setShowEditCollModal] = useState(false);
    const [currencyId, setCurrencyId] = useState('')
    const [collectionCategorySelected, setCollectionCategorySelected] = useState('');
    const [collectionCategories, setCollectionCategories] = useState([]);
    const [listedCount, setListedCount] = useState(0);
    const [editCollectionLogo, setEditCollectionLogo] = useState(null);
    const [editCollectionBanner, setEditCollectionBanner] = useState(null);
    const [editCollectionName, setEditCollectionName] = useState(null);
    const [editCollectionSymbol, setEditCollectionSymbol] = useState(null);
    const [editCollectionDescription, setEditCollectionDescription] = useState(null);
    const [editCollectionCategory, setEditCollectionCategory] = useState(null);
    const [editTwitterLink, setEditTwitterLink] = useState(null);
    const [editFacebookLink, setEditFacebookLink] = useState(null);
    const [editInstagramLink, setEditInstagramLink] = useState(null);
    const [editDiscordLink, setEditDiscordLink] = useState(null);
    const [editTelegramLink, setEditTelegramLink] = useState(null);
    const [editNftnetwork, setEditNftnetwork] = useState(null);
    const [editCollectionId, setEditCollectionId] = useState(null);
    const [editCreatorEarning, setEditCreatorEarning] = useState(null);
    const [collectionLogo, setCollectionLogo] = useState('');
    const [collectionBanner, setCollectionBanner] = useState('');
    const [offers, setOffers] = useState([]);
    const [totalOffers, setTotalOffers] = useState(0);
    const [bestOffer, setBestOffer] = useState(0);
    const [totalFloorPrice, setTotalFloorPrice] = useState(0);
    const [totalVolume, setTotalVolume] = useState(0);
    const [userCollDetails, setUserCollDetails] = useState('');
    const [updateBtn, setUpdateBtn] = useState(false);
    const [filterType, setFilterType] = useState('status');
    const [activities, setActivities] = useState([]);
    const [floorBidAmount, setFloorBidAmount] = useState(null);
    const [floorBidExpires, setFloorBidExpires] = useState(new Date());
    const [lowestFloorPrice, setLowestFloorPrice] = useState(null);
    const [isValidForPlacingBid, setIsValidForPlacingBid] = useState(false);




    /* Method defination for placing floor bid */
    const placeFloorBid = async () => {
        let contract = await getBlockChainContract();
        if (!contract) return;
        if (getAllSessionData().isLoggedInMetaMask !== 'true') {
            showToast('error', 'Please login with MetaMask');
            return;
        }
        try {
            setShowLoader(true)
            const weiBidAmount = web3.utils.toWei(floorBidAmount.toString(), 'ether');
            const expirationTime = Math.floor(new Date(floorBidExpires).getTime() / 1000);
            const estimatedGas = await contract.methods
                .placeFloorBid(props.match.params.id, expirationTime)
                .estimateGas({ from: getAllSessionData().account, value: weiBidAmount });

            console.log("Estimated Gas for placing floor bid:", estimatedGas);
            await new Promise((resolve, reject) => {
                contract.methods.placeFloorBid(props.match.params.id, expirationTime).send({
                    from: getAllSessionData().account,
                    value: weiBidAmount,
                    gas: estimatedGas,
                })
                    .on('transactionHash', (hash) => {
                        console.log('Transaction Hash:', hash);
                    })
                    .on('receipt', (receipt) => {
                        setFloorBidAmount(null)
                        setIsValidForPlacingBid(false)
                        setFloorBidExpires(new Date())
                        setShowLoader(false)
                        console.log('Transaction Receipt:', receipt);
                        showToast('success', 'Floor Bid placed successfully')
                        renderNftsByCollection(props.match.params.id, props.match.params.name);
                        resolve();
                    })
                    .on('error', (error) => {
                        setShowLoader(false)
                        if (error.code === 4001) {
                            console.log('Transaction rejected by user.');
                            showToast('error', "Transaction rejected by the user.");
                        } else {
                            showToast('error', 'Error placing floor bid:' + error);
                            showToast('error', `Unexpected error: ${error.message}`);
                        }
                        reject(error);
                    });
            });
        } catch (error) {
            setShowLoader(false)
            showToast('error', 'Error placing floor bid:' + error);
        }
    }

    /* Method defination for withdraw bid */
    const withdrawFloorBid = async () => {
        let contract = await getBlockChainContract();

        if (!contract) {
            showToast('error', 'Contract is not initialized');
            return;
        }

        try {
            setShowLoader(true)
            // Estimate gas for the transaction
            const estimatedGas = await contract.methods
                .withdrawFloorBid(props.match.params.id)
                .estimateGas({ from: getAllSessionData().account });

            console.log("Estimated Gas for withdrawing floor bid:", estimatedGas);

            // Execute the transaction
            await new Promise((resolve, reject) => {
                contract.methods.withdrawFloorBid(props.match.params.id).send({
                    from: getAllSessionData().account,
                    gas: estimatedGas,
                })
                    .on('transactionHash', (hash) => {
                        console.log('Transaction Hash:', hash);
                    })
                    .on('receipt', (receipt) => {
                        console.log('Transaction Receipt:', receipt);
                        setShowLoader(false)
                        showToast('success', "Your floor bid has been successfully withdrawn");
                        renderNftsByCollection(props.match.params.id, props.match.params.name);
                        resolve();
                    })
                    .on('error', (error) => {
                        showLoader(false)
                        if (error.code === 4001) {
                            console.log('Transaction rejected by user.');
                            showToast('error', "Transaction rejected by the user.");
                        } else {
                            showToast('error', 'Error withdrawing floor bid:' + error);
                            showToast('error', `Unexpected error: ${error.message}`);
                        }
                        reject(error);
                    });
            });
        } catch (error) {
            showToast('error', 'Error in withdrawing floor bid:' + error);
            setShowLoader(false)
            if (error.code === 4001) {
                showToast('error', "Transaction rejected by the user.");
            } else {
                showToast('error', `Unexpected error: ${error.message}`);
            }
        }
    };


    let handleExpiredValue = (date) => {
        console.log(date)
        setFloorBidExpires(date)
    }
    /* Method defination for addFilterType */
    let addFilterType = (param, callback) => {
        console.log(filterType, param, filterType.indexOf(param))
        let filter = '';
        if (filterType.indexOf(param) == -1) {
            filter = filterType + ',' + param;
            setFilterType(filter, callback());
            /*  setTimeout(() => {
                 console.log(filterType)
                 callback()
             }, 4000); */
        }
    }


    const handleCategoryItemClick = async (itemName) => {
        setActiveCatItems(itemName === activeCatItems ? null : itemName);
        if (itemName === 'All') {
            setNftStatus('0')

        } else if (itemName === 'Listed') {
            setNftStatus('1')


        } else if (itemName === 'New') {
            setNftStatus('2')


        } else if (itemName === 'Has offer') {
            setNftStatus('3')

        } else if (itemName === 'On auction') {
            setNftStatus('2')
        }
        /* addFilterType('status', () => {
            searchNftByCollection(props.match.params.id)
        })  */
        setShowLoader(true)
        let contract = await getBlockChainContract();

        if (!contract) return;
        try {
            const query = `
            {
  collection(id: ${props.match.params.id}) {
    id
    name
    description
    backgroundImage
    creator
    volume
    nfts {
      id
      tokenURI
      price
      owner
      creator
    }
  }
}

          `;

            // Fetch collections data from the subgraph
            const response = await axios.post('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', { query });
            const now = Math.floor(Date.now() / 1000);
            const collection = response.data.data.collection;
            const floorBidData = await contract.methods.getFloorBid(collection.id).call();
            console.log('floorBidData', floorBidData);
            const isFloorBidExpired = floorBidData.expirationTime > 0 && now > floorBidData.expirationTime;
            collection.floorBid = {
                bidder: floorBidData.bidder,
                bidAmount: web3.utils.fromWei(floorBidData.bidAmount.toString(), 'ether'),
                expirationTime: floorBidData.expirationTime,
                isExpired: isFloorBidExpired,
            }
            console.log('COLLECTION =>', collection)

            // Process collections and their NFTs
            let offers = [];
            let nfts = collection.nfts;
            const detailedNFTs = await Promise.all(

                nfts.map(async (nft) => {
                    try {
                        // Fetch metadata for each NFT
                        const metadataUrl = nft.tokenURI.replace('ipfs://', 'https://ipfs.io/ipfs/');
                        const { data: metadata } = await axios.get(metadataUrl);

                        // Fetch price, owner, and offer
                        const price = nft.price; // Already part of the struct
                        const owner = nft.owner; // Already part of the struct
                        const offer = await contract.methods.getOffer(nft.id).call();
                        const expirationTime = await contract.methods.getListingExpiration(nft.id).call();
                        const isExpired = expirationTime > 0 && now > expirationTime;
                        const isOfferExpired = offer[2] > 0 && now > offer[2]; // Check expiration	
                        offers.push({
                            offerer: offer[0],
                            offerAmount: offer[1],
                            offerExpiration: offer[2],
                            isExpired: isOfferExpired,
                        })
                        return {
                            ...nft,
                            metadata,
                            price,
                            owner,
                            offer: {
                                offerer: offer[0],
                                offerAmount: offer[1],
                                offerExpiration: offer[2],
                                isExpired: isOfferExpired,
                            },
                            expirationTime: expirationTime > 0 ? expirationTime : null,
                            isExpired,
                        };
                    } catch (error) {
                        showToast('error', 'Error fetching metadata for NFT:' + error);
                        return null; // Handle errors gracefully
                    }

                })
            )


            let arr = [];
            console.log(detailedNFTs)
            if (itemName === 'All') {
                arr = detailedNFTs;
            } else if (itemName === 'Listed') {
                for (let i = 0; i < detailedNFTs.length; i++) {
                    if (detailedNFTs[i].price != null & detailedNFTs[i].price > 0) {
                        arr.push(detailedNFTs[i])
                    }
                }
            } else if (itemName === 'Has offer') {
                for (let i = 0; i < detailedNFTs.length; i++) {
                    if (detailedNFTs[i].offer != null & detailedNFTs[i].offer.offerer != "0x0000000000000000000000000000000000000000") {
                        arr.push(detailedNFTs[i])
                    }
                }
            }

            setNftCollection(arr)
            setShowLoader(false)


        } catch (error) {
            setShowLoader(false)
            console.log(error)
            showToast('error', 'Error fetching all collections:' + error);
        }



    }

    const handleCurrencyItemClick = (currencyname) => {
        setActiveCurrencyItem(currencyname === activeCurrencyItem ? null : currencyname)
        addFilterType('currency',
            () => {
                if (currencyname === 'ETH') {
                    setCurrencyId('3')
                } else if (currencyname === 'DOGE') {
                    setCurrencyId('124')
                } else if (currencyname === 'BTC') {
                    setCurrencyId('2')
                }
            })

    }




    /*  get collection details */
    let getCollectionDetails = (param) => {
        setCollectionId(param)
        let payload = { "entityId": param }
        setShowLoader(true)
        console.log(payload)
        callAPI('post', NFTAPIBASENAME + '/nft/market/public/getCollectionDetails', payload, false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                setUserCollDetails(response.nftCollections[0])
                setCollectionName(response.nftCollections[0].nftCollectionName);
                setCoverPicture(COLLECTIONIMAGEBASEURL + '/' + response.nftCollections[0].collectionBannerName);
                setCollectionImage(COLLECTIONIMAGEBASEURL + '/' + response.nftCollections[0].collectionLogoName);
                renderVolumePriceChart();
                renderFloorPriceChart();
                getAllOffersByCollection(param)
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    /* method defination for get all offers by collections */
    let getAllOffersByCollection = (collectionId) => {
        let payload = { "entityId": collectionId, "pageNo": "1", "pageSize": "50" }
        setShowLoader(true)
        callAPI('post', NFTAPIBASENAME + '/nft/market/public/getAllOfferByCollection', payload, false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.nftOffers != null) {

                    setOffers(response.nftOffers);
                    setTotalOffers(response.totalCount)
                    //setOffers([{"nftOfferId":0,"entityId":1,"offerType":2,"offerPrice":"100","offerCurrency":"3","floorPrice":null,"durationId":3,"offerStatus":0,"createdOn":null,"expiredOn":null,"startDate":"2023-12-10 01:00:00","endDate":"2023-12-11 01:00:00","createdBy":"70418f1a-c8af-11ed-bf08-ff1bea7c59fb"},{"nftOfferId":0,"entityId":1,"offerType":2,"offerPrice":"101","offerCurrency":"3","floorPrice":null,"durationId":3,"offerStatus":0,"createdOn":null,"expiredOn":null,"startDate":"2023-12-10 01:00:00","endDate":"2023-12-11 01:00:00","createdBy":"70418f1a-c8af-11ed-bf08-ff1bea7c59fb"},{"nftOfferId":0,"entityId":1,"offerType":2,"offerPrice":"100","offerCurrency":"3","floorPrice":null,"durationId":3,"offerStatus":0,"createdOn":null,"expiredOn":null,"startDate":"2023-12-10 01:00:00","endDate":"2023-12-11 01:00:00","createdBy":"70418f1a-c8af-11ed-bf08-ff1bea7c59fb"},{"nftOfferId":0,"entityId":1,"offerType":2,"offerPrice":"98","offerCurrency":"3","floorPrice":null,"durationId":3,"offerStatus":0,"createdOn":null,"expiredOn":null,"startDate":"2023-12-10 01:00:00","endDate":"2023-12-11 01:00:00","createdBy":"70418f1a-c8af-11ed-bf08-ff1bea7c59fb"},{"nftOfferId":0,"entityId":1,"offerType":2,"offerPrice":"100","offerCurrency":"3","floorPrice":null,"durationId":3,"offerStatus":0,"createdOn":null,"expiredOn":null,"startDate":"2023-12-10 01:00:00","endDate":"2023-12-11 01:00:00","createdBy":"70418f1a-c8af-11ed-bf08-ff1bea7c59fb"},{"nftOfferId":0,"entityId":1,"offerType":2,"offerPrice":"97","offerCurrency":"3","floorPrice":null,"durationId":3,"offerStatus":0,"createdOn":null,"expiredOn":null,"startDate":"2023-12-10 01:00:00","endDate":"2023-12-11 01:00:00","createdBy":"70418f1a-c8af-11ed-bf08-ff1bea7c59fb"}])
                    setTimeout(() => {
                        let bestOffer = Math.min.apply(Math, offers.map(a => a.offerPrice));
                        //console.log('best Offer', bestOffer)
                        //setBestOffer(bestOffer)
                        let sum = 0;
                        for (let i = 0; i < offers.length; i++) {
                            if (offers[i].floorPrice != null) {

                                sum = parseFloat(sum) + parseFloat(offers[i].floorPrice)
                            }
                        }
                        setTotalFloorPrice(sum)
                    }, 1000);
                }
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })

    }
    /* rendering volume & price chart */
    let renderVolumePriceChart = () => {
        let options = {
            responsive: true,
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: true,
                    text: 'Volume & Price',
                },
            },
        };
        setVolumePriceOptions(options)

        let labels = ['Sept', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];

        let data = {
            labels,
            datasets: [
                {
                    label: 'Dataset 1',
                    data: [0, 3, 6, 9, 7, 4, 5, 8],
                    borderColor: 'rgb(255, 99, 132)',
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                },

            ],
        };
        setVolumePriceData(data)
    }
    /* rendering volume & price chart */
    let renderFloorPriceChart = () => {
        let options = {
            responsive: true,
            plugins: {
                legend: {
                    display: false,
                },
                title: {
                    display: true,
                    text: 'Floor Price',
                },
            },
        };
        setFloorPriceOptions(options)

        let labels = ['Sept', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];

        let data = {
            labels,
            datasets: [
                {
                    label: 'Dataset 1',
                    data: [0, 3, 6, 9, 7, 4, 5, 8],
                    borderColor: 'rgb(255, 99, 132)',
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                },
            ],
        };
        setFloorPriceData(data)
    }

    /* Method defination for handling search NFT */
    const handleSearchNfts = async () => {
        if (searchString != '') {
            setShowLoader(true)
            let contract = await getBlockChainContract();

            if (!contract) return;
            try {
                const query = `
            {
  collection(id: ${props.match.params.id}) {
    id
    name
    description
    backgroundImage
    creator
    volume
    nfts {
      id
      tokenURI
      price
      owner
      creator
    }
  }
}

          `;

                // Fetch collections data from the subgraph
                const response = await axios.post('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', { query });
                const now = Math.floor(Date.now() / 1000);
                const collection = response.data.data.collection;
                const floorBidData = await contract.methods.getFloorBid(collection.id).call();
                console.log('floorBidData', floorBidData);
                const isFloorBidExpired = floorBidData.expirationTime > 0 && now > floorBidData.expirationTime;
                collection.floorBid = {
                    bidder: floorBidData.bidder,
                    bidAmount: web3.utils.fromWei(floorBidData.bidAmount.toString(), 'ether'),
                    expirationTime: floorBidData.expirationTime,
                    isExpired: isFloorBidExpired,
                }
                console.log('COLLECTION =>', collection)

                // Process collections and their NFTs
                let offers = [];
                let nfts = collection.nfts;
                const detailedNFTs = await Promise.all(

                    nfts.map(async (nft) => {
                        try {
                            // Fetch metadata for each NFT
                            const metadataUrl = nft.tokenURI.replace('ipfs://', 'https://ipfs.io/ipfs/');
                            const { data: metadata } = await axios.get(metadataUrl);

                            // Fetch price, owner, and offer
                            const price = nft.price; // Already part of the struct
                            const owner = nft.owner; // Already part of the struct
                            const offer = await contract.methods.getOffer(nft.id).call();
                            const expirationTime = await contract.methods.getListingExpiration(nft.id).call();
                            const isExpired = expirationTime > 0 && now > expirationTime;
                            const isOfferExpired = offer[2] > 0 && now > offer[2]; // Check expiration	
                            offers.push({
                                offerer: offer[0],
                                offerAmount: offer[1],
                                offerExpiration: offer[2],
                                isExpired: isOfferExpired,
                            })
                            return {
                                ...nft,
                                metadata,
                                price,
                                owner,
                                offer: {
                                    offerer: offer[0],
                                    offerAmount: offer[1],
                                    offerExpiration: offer[2],
                                    isExpired: isOfferExpired,
                                },
                                expirationTime: expirationTime > 0 ? expirationTime : null,
                                isExpired,
                            };
                        } catch (error) {
                            showToast('error', 'Error fetching metadata for NFT:' + error);
                            return null; // Handle errors gracefully
                        }

                    })
                )


                let arr = [];
                console.log(detailedNFTs)
                for (let i = 0; i < detailedNFTs.length; i++) {
                    console.log(detailedNFTs[i].metadata.name.toLowerCase(), searchString.toLowerCase())
                    if (detailedNFTs[i].metadata.name.toLowerCase().indexOf(searchString.toLowerCase()) != -1) {
                        arr.push(detailedNFTs[i])
                    }
                }
                setNftCollection(arr)
                setShowLoader(false)


            } catch (error) {
                setShowLoader(false)
                console.log(error)
                showToast('error', 'Error fetching all collections:' + error);
            }
        } else {
            renderNftsByCollection(props.match.params.id, props.match.params.name);
        }

    }


    /* get nft list by collection id */
    const searchNftByCollection = (param) => {
        // console.log('PARAM', param)
        setCollectionId(param)
        //console.log('ORDERING TYPE IS:', orderingType)
        //console.log(filterType,toValue,fromValue)

        let payload = {
            "entityId": param,
            "orderingType": orderingType,
            "pageNo": "1",
            "pageSize": "10",
            "searchString": searchString,
            "filterType": filterType,
            "status": nftStatus,
            "currencyId": currencyId,
            "fromValue": fromValue,
            "toValue": toValue
        }

        setShowLoader(true);
        callAPI('post', NFTAPIBASENAME + '/nft/market/public/searchAllNftsByCollection', payload, false).then((res) => {
            console.log('SEARCH RESPONSE:', res.data)
            let response = res.data;
            setShowLoader(false)
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                setNftCollection(response.nfts)
            }
        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    let openEditCollModal = () => {
        setShowEditCollModal(true)
    }

    //click to edit collection

    const editUserCollection = (data) => {

        console.log('Edit user data:', data)
        setEditCollectionLogo(data.collectionLogoName)
        setEditCollectionBanner(data.collectionBannerName)
        setEditTwitterLink(data.twitterLink);
        setEditFacebookLink(data.facebookLink);
        setEditInstagramLink(data.instagramLink);
        setEditDiscordLink(data.discordLink);
        setEditTelegramLink(data.telegramLink);

        setEditCollectionName(data.nftCollectionName);

        setEditCollectionDescription(data.description);

        setEditCollectionId(data.nftCollectionId)


    }

    const updateCollection = () => {
        // console.log(editFacebookLink)
        if (collectionLogo != null && collectionBanner != null && editCollectionDescription != null) {
            const formData = new FormData();
            formData.append("col_id", editCollectionId);
            if (collectionLogo) {
                formData.append("logo_file", collectionLogo);
            } else {
                formData.append("logo_name", editCollectionLogo)
            }
            if (collectionBanner) {
                formData.append("banner_file", collectionBanner);
            } else {
                formData.append("banner_name", editCollectionBanner)
            }
            formData.append("col_desc", editCollectionDescription);
            formData.append("owner_id", getAllSessionData().uuid);

            formData.append("twitter_link", editTwitterLink);
            formData.append("facebook_link", editFacebookLink);
            formData.append("instagram_link", editInstagramLink);
            formData.append("telegram_link", editTelegramLink);
            formData.append("discord_link", editDiscordLink);

            setShowLoader(true);
            axios.post(NFTAPIBASENAME + '/nft/market/updateNftCollection', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": "bearer " + getAllSessionData().token,
                },
            })
                .then((res) => {
                    let response = res.data;
                    setShowLoader(false);
                    if (response.error.error_data != 0) {
                        showToast('error', response.error.error_msg)
                    } else {
                        setShowEditCollModal(false)
                        showToast('success', 'Update collection successfully')
                        setTimeout(() => {
                            window.location.reload()
                        }, 2000)
                    }
                })
        } else {
            showToast('error', 'Please insert all mandatory fields')
        }
    }

    /* Method defination for handling price filter */
    let handlePriceFilter = async () => {
        let min = document.getElementById('priceFilterMin').value;
        let max = document.getElementById('priceFilterMax').value;
        console.log(min, max)

        if (min != '' && max != '') {
            setFromValue(parseFloat(min))
            setToValue(parseFloat(max))
            setPriceFilterIntiated(true)
            let arr = [];
            console.log(min, max)
            setShowLoader(true)
            let contract = await getBlockChainContract();

            if (!contract) return;
            try {
                const query = `
            {
  collection(id: ${props.match.params.id}) {
    id
    name
    description
    backgroundImage
    creator
    volume
    nfts {
      id
      tokenURI
      price
      owner
      creator
    }
  }
}

          `;

                // Fetch collections data from the subgraph
                const response = await axios.post('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', { query });
                const now = Math.floor(Date.now() / 1000);
                const collection = response.data.data.collection;
                const floorBidData = await contract.methods.getFloorBid(collection.id).call();
                console.log('floorBidData', floorBidData);
                const isFloorBidExpired = floorBidData.expirationTime > 0 && now > floorBidData.expirationTime;
                collection.floorBid = {
                    bidder: floorBidData.bidder,
                    bidAmount: web3.utils.fromWei(floorBidData.bidAmount.toString(), 'ether'),
                    expirationTime: floorBidData.expirationTime,
                    isExpired: isFloorBidExpired,
                }
                console.log('COLLECTION =>', collection)

                // Process collections and their NFTs
                let offers = [];
                let nfts = collection.nfts;
                const detailedNFTs = await Promise.all(

                    nfts.map(async (nft) => {
                        try {
                            // Fetch metadata for each NFT
                            const metadataUrl = nft.tokenURI.replace('ipfs://', 'https://ipfs.io/ipfs/');
                            const { data: metadata } = await axios.get(metadataUrl);

                            // Fetch price, owner, and offer
                            const price = nft.price; // Already part of the struct
                            const owner = nft.owner; // Already part of the struct
                            const offer = await contract.methods.getOffer(nft.id).call();
                            const expirationTime = await contract.methods.getListingExpiration(nft.id).call();
                            const isExpired = expirationTime > 0 && now > expirationTime;
                            const isOfferExpired = offer[2] > 0 && now > offer[2]; // Check expiration	
                            offers.push({
                                offerer: offer[0],
                                offerAmount: offer[1],
                                offerExpiration: offer[2],
                                isExpired: isOfferExpired,
                            })
                            return {
                                ...nft,
                                metadata,
                                price,
                                owner,
                                offer: {
                                    offerer: offer[0],
                                    offerAmount: offer[1],
                                    offerExpiration: offer[2],
                                    isExpired: isOfferExpired,
                                },
                                expirationTime: expirationTime > 0 ? expirationTime : null,
                                isExpired,
                            };
                        } catch (error) {
                            showToast('error', 'Error fetching metadata for NFT:' + error);
                            return null; // Handle errors gracefully
                        }

                    })
                )


                let arr = [];
                console.log(detailedNFTs)
                for (let i = 0; i < detailedNFTs.length; i++) {
                    //console.log(parseFloat(web3.utils.fromWei(detailedNFTs[i].price.toString(), 'ether')),fromValue.toString(), parseFloat(min), parseFloat(max),parseFloat(web3.utils.fromWei(detailedNFTs[i].price.toString(), 'ether')) >= parseFloat(min),parseFloat(web3.utils.fromWei(detailedNFTs[i].price.toString(), 'ether')) <= parseFloat(max))

                    if (detailedNFTs[i].price != null && detailedNFTs[i].price != undefined && parseFloat(web3.utils.fromWei(detailedNFTs[i].price.toString(), 'ether')) >= parseFloat(min) && parseFloat(web3.utils.fromWei(detailedNFTs[i].price.toString(), 'ether')) <= parseFloat(max)) {
                        arr.push(detailedNFTs[i])
                    }
                }
                setNftCollection(arr)
                setShowLoader(false)
            } catch (error) {
                setShowLoader(false)
                console.log(error)
                showToast('error', 'Error fetching all collections:' + error);
            }

        } else {
            showToast('error', 'Please provide valid Min & Max Value');
        }
    }

    /* Method defination for get Activity */
    let getCollectionActivity = (collectionId, filtertype) => {
        let payload = { "entityId": collectionId, "pageNo": "1", "pageSize": "50", "filterType": filtertype }
        setShowLoader(true)
        console.log(payload)
        callAPI('post', NFTAPIBASENAME + '/nft/market/public/getAllActivityByCollection', payload, false).then((res) => {
            let response = res.data;
            setShowLoader(false);
            console.log(response);
            if (response.error.error_data != 0) {
                showToast('error', response.error.error_msg)
            } else {
                if (response.nftActivities != null) {
                    setActivities(response.nftActivities)
                }
            }

        }, (error) => {
            setShowLoader(false);
            showHttpError(error)
        })
    }

    /* Method defination for get all Nft by collection */
    const renderNftsByCollection = async (id, name) => {
        setShowLoader(true)
        setListedCount(0)
        let contract = await getBlockChainContract();

        //if (!contract) return;
        try {
            const query = `
            {
  collection(id: ${id}) {
    id
    name
    description
    backgroundImage
    creator
    volume
    nfts {
      id
      tokenURI
      price
      owner
      creator
    }
  }
}

          `;

            // Fetch collections data from the subgraph
            const response = await axios.post('https://api.studio.thegraph.com/query/108358/paybito_nft_marketplace/v0.0.1', { query });
            const now = Math.floor(Date.now() / 1000);
            const collection = response.data.data.collection;
            if(contract){
                const floorBidData = await contract.methods.getFloorBid(collection.id).call();
                console.log('floorBidData', floorBidData);
                const isFloorBidExpired = floorBidData.expirationTime > 0 && now > floorBidData.expirationTime;
                collection.floorBid = {
                    bidder: floorBidData.bidder,
                    bidAmount: web3.utils.fromWei(floorBidData.bidAmount.toString(), 'ether'),
                    expirationTime: floorBidData.expirationTime,
                    isExpired: isFloorBidExpired,
                }

            }
            console.log('COLLECTION =>', collection)
            setTotalVolume(collection.volume)

            console.log('listedCount', listedCount)
            // Process collections and their NFTs
            let offers = [];
            let nfts = collection.nfts;
            const detailedNFTs = await Promise.all(

                nfts.map(async (nft) => {
                    try {
                        // Fetch metadata for each NFT
                        const metadataUrl = nft.tokenURI.replace('ipfs://', 'https://ipfs.io/ipfs/');
                        const { data: metadata } = await axios.get(metadataUrl);

                        // Fetch price, owner, and offer
                        const price = nft.price; // Already part of the struct
                        const owner = nft.owner; // Already part of the struct
                        
                                let offer = null;
                                let isOfferExpired = null;
                                let isExpired = null;
                                let expirationTime = null
                        
                        if(contract){
                            offer = await contract.methods.getOffer(nft.id).call();
                            expirationTime = await contract.methods.getListingExpiration(nft.id).call();
                            isExpired = expirationTime > 0 && now > expirationTime;
                            isOfferExpired = offer[2] > 0 && now > offer[2]; // Check expiration	
                            if (offer[0] != '0x0000000000000000000000000000000000000000') {
                                offers.push({
                                    asset: metadata.name,
                                    offerer: offer[0],
                                    offerAmount: offer[1],
                                    offerExpiration: offer[2],
                                    isExpired: isOfferExpired,
                                })
    
                            }

                        }
                        return {
                            ...nft,
                            metadata,
                            price,
                            owner,
                            offer: offer !== null ? {
                                offerer: offer[0],
                                offerAmount: offer[1],
                                offerExpiration: offer[2],
                                isExpired: isOfferExpired,
                            } : {},
                            expirationTime: expirationTime !== null && expirationTime > 0  ? expirationTime : null,
                            isExpired : isExpired !== null ? isExpired : null,
                        };
                    } catch (error) {
                        showToast('error', 'Error fetching metadata for NFT:' + error);
                        return null; // Handle errors gracefully
                    }

                })
            )

            collection.nfts = detailedNFTs;
            console.log(offers)
            setOffers(offers)
            setTotalOffers(offers.length);
            setCollectionImage(collection.backgroundImage.replace('ipfs://', 'https://ipfs.io/ipfs/'))
            setCollectionId(collection.id)
            setCollectionName(collection.name)
            setCollectionDesc(collection.description)
            setCoverPicture(collection.backgroundImage.replace('ipfs://', 'https://ipfs.io/ipfs/'));
            setUserCollDetails(collection)
            setNftCollection(collection.nfts)
            setShowLoader(false)
            let sortedNft = nftCollection.sort(function (a, b) {
                let returnable = a.price != null && b.price != null ? a.price - b.price : null
                return returnable
            })

            sortedNft = sortedNft.filter(elem => elem.price != null && !elem.isExpired)
            console.log('sortedNft', sortedNft)

            //console.log('LOWEST PRICE', sortedNft[0].price, sortedNft[sortedNft.length - 1].price);
            if (sortedNft.length > 0 && sortedNft[0].price != undefined) {
                setLowestFloorPrice(sortedNft[0].price)
            }
            sortedNft.filter(nft => { console.log(nft.price != null && !nft.isExpired); nft.price != null && !nft.isExpired ? setListedCount(parseInt(listedCount) + 1) : setListedCount(listedCount) })
        } catch (error) {
            setShowLoader(false)
            console.log(error)
            showToast('error', 'Error fetching all collections:' + error);
        }
    }

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        /*  if (!checkIfUserIsLoggedIn()) {
             showToast('error', 'Please login to continue',);
             setTimeout(() => {
                 props.history.push("/");
             }, 1000);
         } else {
             setShowCreateColBtn(true);
             //console.log(props.match.params.id,collectionId)
         } */
        // getCollectionDetails(props.match.params.id);
        // searchNftByCollection(props.match.params.id)
        // console.log('selected filter', nftStatus)
        // getCollectionActivity(props.match.params.id, 'ALL')

        renderNftsByCollection(props.match.params.id, props.match.params.name);
        return () => { setListedCount(0) };

    }, [collectionLogo, collectionId, collectionName, collectionImage]);

    return (
        <Fragment>
            <Header />
            <div className="shop-box-inner">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-12 pl-0 pr-0">
                            <div className="coverPictureSection">
                                {
                                    coverPicture ?
                                        (
                                            <img src={coverPicture} className="cover-picture" />
                                        ) :
                                        (
                                            <img src="https://img.freepik.com/free-vector/v915-red-blue_53876-174923.jpg" className="cover-picture" />

                                        )
                                }
                            </div>
                        </div>
                    </div>
                    <div className="profile-name-section">
                        <div className="row mb-2">
                            <div className="col-md-5">
                                <div className="row">
                                    <div className="col-md-6">
                                        {
                                            collectionImage ?
                                                (
                                                    <img src={collectionImage} className="img-fluid" alt="Image" style={{ width: '224px', height: '224px' }} />

                                                ) :
                                                (
                                                    <img src="https://cdn-icons-png.flaticon.com/512/149/149071.png" className="img-fluid" alt="Image" style={{ width: '224px', height: '224px' }} />

                                                )
                                        }
                                    </div>
                                    <div className="col-md-6">
                                        <h1 className="specification-user">{collectionName}</h1>

                                    </div>
                                </div>

                            </div>
                            <div className="col-md-7">

                                <div className="row  specification-user">
                                    <div className="col-md-3">
                                        <div>{web3.utils.fromWei(totalVolume.toString(), 'ether')} ETH</div>
                                        <div>Total Volume</div>
                                    </div>
                                    <div className="col-md-3">
                                        <div> {lowestFloorPrice != null ? web3.utils.fromWei(lowestFloorPrice.toString(), 'ether') + 'ETH' : '-'}</div>
                                        <div>Floor Price</div>
                                    </div>
                                    {/* <div className="col-md-3">
                                        <div>0.07 ETH</div>
                                        <div>Best Offer</div>
                                    </div> */}
                                    <div className="col-md-3">
                                        <div>{listedCount}</div>
                                        <div>Listed</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <p className="col-md-12" style={{ fontSize: '16px', fontWeight: '500' }}>{collectionDesc}</p>
                    </div>
                    {/* Type selection section */}
                    <div className="type-nav mb-2 mt-2 row">
                        <div className="col-md-8 col-sm-8">
                            <ul>
                                <li><a href="javascript:void(0)" onClick={() => { setDisplayTab('items') }} className={`${isDisplayTab == 'items' ? 'active' : ''}`}>Items</a></li>
                                <li><a href="javascript:void(0)" onClick={() => { setDisplayTab('offers') }} className={`${isDisplayTab == 'offers' ? 'active' : ''}`}>Offers</a></li>
                                {/* <li><a href="javascript:void(0)" onClick={() => { setDisplayTab('analytics') }} className={`${isDisplayTab == 'analytics' ? 'active' : ''}`}>Analytics</a></li> */}
                                {/* <li><a href="javascript:void(0)" onClick={() => { setDisplayTab('activity') }} className={`${isDisplayTab == 'activity' ? 'active' : ''}`}>Activity</a></li> */}
                            </ul>
                        </div>
                        <div className="col-md-4 col-sm-4 text-right">
                            {getAllSessionData() != null && userCollDetails.ownerId == getAllSessionData().uuid && getAllSessionData().loginPlatform == 'paybito' && <Fragment>
                                <span className="fa fa-edit mt-4 mr-3" style={{ cursor: 'pointer' }} title='Edit Collection' role='button' onClick={() => {
                                    console.log('click')
                                    openEditCollModal();
                                    editUserCollection(userCollDetails)
                                }}></span>
                                <span className="fa fa-ellipsis-v mt-4" ></span>
                            </Fragment>}
                        </div>
                    </div>
                    {/* Item section */}
                    {isDisplayTab == 'items' && <div className="row mt-3">
                        <div className="col-xl-9 col-lg-9 col-sm-12 col-xs-12 shop-content-right">
                            {/* <div className="right-product-box">
                                <div className="product-item-filter row"> */}
                            {/* <div className="col-12 col-sm-8 text-center text-sm-left">
                                        <div className="toolbar-sorter-right">
                                             <span>Sort by </span>
                                            <select className="form-control" data-placeholder="$ USD" style={{ display: 'block' }}
                                             onChange={(e) => {
                                                 console.log('ORDERINGTYPE:',e.target.value)
                                                 setOrderingType(e.target.value);
                                                 searchNftByCollection(props.match.params.id);
                                                }}>
                                                <option>Sort By</option>
                                                <option value={0}>Low Price → High Price</option>
                                                <option value={2}>Popularity</option>
                                                <option value={1}>High Price → Low Price</option>
                                                <option value={3}>Best Selling</option>
                                                <option value={4}>Highest Selling</option>
                                            </select> 
                                        </div>
                                         <p>Showing all 4 results</p>
                                    </div> */}
                            {/* <div className="col-12 col-sm-4 text-center text-sm-right"> */}
                            {/*  <ul className="nav nav-tabs ml-auto">
                                    <li>
                                        <a className="nav-link active" href="#grid-view" data-toggle="tab"> <i className="fa fa-th"></i> </a>
                                    </li>
                                    <li>
                                        <a className="nav-link" href="#list-view" data-toggle="tab"> <i className="fa fa-list-ul"></i> </a>
                                    </li>
                                </ul> */}
                            {/* {
                                    showCreateColBtn && 
                                    <Link to="/create-collection" className="btn btn-primary">Create Collection</Link>
                                } */}
                            {/* </div>
                                </div> */}

                            <div className="product-categorie-box">
                                <div className="tab-content">
                                    <div role="tabpanel" className="tab-pane fade show active" id="grid-view">
                                        <div className="row">
                                            {
                                                nftCollection.map((data) => (
                                                    <Fragment>

                                                        {data.id != null && data.id != undefined && !data.isExpired && <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4" key={data.id}>
                                                            <div className="products-single fix">
                                                                <div className="box-img-hover" to={`/asset/` + props.match.params.id + `/` + data.id} data-toggle="tooltip" data-placement="right" title="View">
                                                                    {/* <div className="type-lb">
                                                                            <p className="sale">Sale</p>
                                                                        </div> */}
                                                                    <Link to={`/asset/` + props.match.params.id + `/` + data.id} data-toggle="tooltip" data-placement="right" title="View">
                                                                        {data.metadata != undefined && <img src={data.metadata.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} className="img-fluid" alt="Image" style={{ maxWidth: '250px', height: '200px' }} />}
                                                                    </Link>
                                                                    {/* <div className="mask-icon"> */}
                                                                    {/* <ul>  */}
                                                                    {/* <li><Link to={`/asset/` + props.match.params.id+ `/` + data.id} data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></Link></li> */}
                                                                    {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Compare"><i className="fas fa-sync-alt"></i></a></li> */}
                                                                    {/* <li><a href="javascript:void(0);" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li> */}
                                                                    {/* </ul> */}
                                                                    {/* <a className="cart" href="javascript:void(0);" onClick={() => { handleCartManipulation(data, 'add') }}>Add to Cart</a> */}
                                                                    {/* </div> */}
                                                                </div>
                                                                <div className="why-text">
                                                                    {data.metadata != undefined && <h3>{data.metadata.name}</h3>}
                                                                    {/*  {data.metadata != undefined && <h4>{data.metadata.description.length > 8 ? data.metadata.description.slice(0, 8) : data.metadata.description}</h4>} */}
                                                                    <h5> {data.price > 0 && data.price != null && !data.isExpired ? web3.utils.fromWei(data.price.toString(), 'ether') + 'ETH' : 'Not For Sale'}</h5>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                    </Fragment>
                                                ))
                                            }


                                        </div>
                                    </div>
                                    <div role="tabpanel" className="tab-pane fade" id="list-view">
                                        <div className="list-view-box">
                                            <div className="row">
                                                <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                                    <div className="products-single fix">
                                                        <div className="box-img-hover">
                                                            {/* <div className="type-lb">
                                                                    <p className="new">New</p>
                                                                </div> */}
                                                            <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                                                            <div className="mask-icon">
                                                                <ul>
                                                                    <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                                                    {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Compare"><i className="fas fa-sync-alt"></i></a></li> */}
                                                                    <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li>
                                                                </ul>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6 col-md-6 col-lg-8 col-xl-8">
                                                    <div className="why-text full-width">
                                                        <h4>Lorem ipsum dolor sit amet</h4>
                                                        <h5> <del>$ 60.00</del> $40.79</h5>
                                                        <p>Integer tincidunt aliquet nibh vitae dictum. In turpis sapien, imperdiet quis magna nec, iaculis ultrices ante. Integer vitae suscipit nisi. Morbi dignissim risus sit amet orci porta, eget aliquam purus
                                                            sollicitudin. Cras eu metus felis. Sed arcu arcu, sagittis in blandit eu, imperdiet sit amet eros. Donec accumsan nisi purus, quis euismod ex volutpat in. Vestibulum eleifend eros ac lobortis aliquet.
                                                            Suspendisse at ipsum vel lacus vehicula blandit et sollicitudin quam. Praesent vulputate semper libero pulvinar consequat. Etiam ut placerat lectus.</p>
                                                        {/* <a className="btn hvr-hover" href="#">Add to Cart</a> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="list-view-box">
                                            <div className="row">
                                                <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                                    <div className="products-single fix">
                                                        <div className="box-img-hover">
                                                            {/* <div className="type-lb">
                                                                    <p className="sale">Sale</p>
                                                                </div> */}
                                                            <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                                                            <div className="mask-icon">
                                                                <ul>
                                                                    <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                                                    {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Compare"><i className="fas fa-sync-alt"></i></a></li> */}
                                                                    <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li>
                                                                </ul>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6 col-md-6 col-lg-8 col-xl-8">
                                                    <div className="why-text full-width">
                                                        <h4>Lorem ipsum dolor sit amet</h4>
                                                        <h5> <del>$ 60.00</del> $40.79</h5>
                                                        <p>Integer tincidunt aliquet nibh vitae dictum. In turpis sapien, imperdiet quis magna nec, iaculis ultrices ante. Integer vitae suscipit nisi. Morbi dignissim risus sit amet orci porta, eget aliquam purus
                                                            sollicitudin. Cras eu metus felis. Sed arcu arcu, sagittis in blandit eu, imperdiet sit amet eros. Donec accumsan nisi purus, quis euismod ex volutpat in. Vestibulum eleifend eros ac lobortis aliquet.
                                                            Suspendisse at ipsum vel lacus vehicula blandit et sollicitudin quam. Praesent vulputate semper libero pulvinar consequat. Etiam ut placerat lectus.</p>
                                                        {/* <a className="btn hvr-hover" href="#">Add to Cart</a> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="list-view-box">
                                            <div className="row">
                                                <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                                    <div className="products-single fix">
                                                        <div className="box-img-hover">
                                                            {/* <div className="type-lb">
                                                                    <p className="sale">Sale</p>
                                                                </div> */}
                                                            <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                                                            <div className="mask-icon">
                                                                <ul>
                                                                    <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                                                    {/* <li><a href="#" data-toggle="tooltip" data-placement="right" title="Compare"><i className="fas fa-sync-alt"></i></a></li> */}
                                                                    <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li>
                                                                </ul>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6 col-md-6 col-lg-8 col-xl-8">
                                                    <div className="why-text full-width">
                                                        <h4>Lorem ipsum dolor sit amet</h4>
                                                        <h5> <del>$ 60.00</del> $40.79</h5>
                                                        <p>Integer tincidunt aliquet nibh vitae dictum. In turpis sapien, imperdiet quis magna nec, iaculis ultrices ante. Integer vitae suscipit nisi. Morbi dignissim risus sit amet orci porta, eget aliquam purus
                                                            sollicitudin. Cras eu metus felis. Sed arcu arcu, sagittis in blandit eu, imperdiet sit amet eros. Donec accumsan nisi purus, quis euismod ex volutpat in. Vestibulum eleifend eros ac lobortis aliquet.
                                                            Suspendisse at ipsum vel lacus vehicula blandit et sollicitudin quam. Praesent vulputate semper libero pulvinar consequat. Etiam ut placerat lectus.</p>
                                                        {/* <a className="btn hvr-hover" href="#">Add to Cart</a> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* </div> */}
                        </div>
                        <div className="col-xl-3 col-lg-3 col-sm-12 col-xs-12 sidebar-shop-left">

                            <div className="product-categori">
                                <div className="search-product">
                                    <div>
                                        <input className="form-control" placeholder="Search here..." type="text" onChange={(e) => { setSearchString(e.target.value) }} />
                                        <button onClick={() => { handleSearchNfts() }}> <i className="fa fa-search" ></i> </button>
                                    </div>
                                </div>
                                <div className="filter-sidebar-left">
                                    <div className="title-left">
                                        <h3>Categories</h3>
                                    </div>
                                    <div className="list-group list-group-collapse list-group-sm list-group-tree" id="list-group-men" data-children=".sub-men">
                                        <div className="list-group-collapse sub-men">
                                            <a onClick={() => { setStatusCategory(!showStatusCategory) }} className="list-group-item list-group-item-action" href="javascript:void(0)" >Status <small className="text-muted">(100)</small><i className={`ml-2 fa + ${showStatusCategory ? 'fa-caret-up' : 'fa-caret-down'}`} aria-hidden="true"></i>
                                            </a>
                                            {showStatusCategory && <div className="collapse show" data-parent="#list-group-men">
                                                <div className="list-group">
                                                    <a className={`list-group-item list-group-item-action ${activeCatItems === 'All' ? 'active' : ''}`} onClick={() => { handleCategoryItemClick('All') }} style={{ cursor: 'pointer' }}>All{/* <small className="text-muted">(50)</small> */}</a>
                                                    <a className={`list-group-item list-group-item-action ${activeCatItems === 'Listed' ? 'active' : ''}`} onClick={() => { handleCategoryItemClick('Listed') }} style={{ cursor: 'pointer' }}>Listed {/* <small className="text-muted">(10)</small> */}</a>
                                                    {/* <a className={`list-group-item list-group-item-action ${activeCatItems === 'New' ? 'active' : ''}`} onClick={() => { handleCategoryItemClick('New') }}>New <small className="text-muted">(10)</small></a>*/}
                                                    {/* <a className={`list-group-item list-group-item-action ${activeCatItems === 'On auction' ? 'active' : ''}`} onClick={() => { handleCategoryItemClick('On auction') }}>On auction <small className="text-muted">(10)</small></a> */}
                                                    <a className={`list-group-item list-group-item-action ${activeCatItems === 'Has offer' ? 'active' : ''}`} onClick={() => { handleCategoryItemClick('Has offer') }} style={{ cursor: 'pointer' }}>Has offer {/* <small className="text-muted">(10)</small> */}</a>

                                                </div>
                                                {/* <div className="list-group mt-2">
                                                    <select name="" id="" className='form-control' value={statusFilter} onChange={onFilterStatusChange}>
                                                        <option value="">--Select Status</option>
                                                        <option value="0">All</option>
                                                        <option value="1">Listed</option>
                                                        <option value="3">New</option>
                                                        <option value="2">On auction</option>
                                                        <option value="4">Has offer</option>
                                                    </select>
                                                </div> */}
                                            </div>}
                                        </div>
                                        <div className="list-group-collapse sub-men">
                                            <a onClick={() => { setCurrencyCategory(!showCurrencyCategory) }} className="list-group-item list-group-item-action" href="javascript:void(0)" >Currency <small className="text-muted">(3)</small><i className={`ml-2 fa + ${showCurrencyCategory ? 'fa-caret-up' : 'fa-caret-down'}`} aria-hidden="true"></i>
                                            </a>
                                            {showCurrencyCategory && <div className="collapse show" data-parent="#list-group-men">
                                                <div className="list-group">
                                                    <a href="javascript:void(0)" className={`list-group-item list-group-item-action ${activeCurrencyItem === 'ETH' ? 'active' : ''}`} onClick={() => { handleCurrencyItemClick('ETH') }}>ETH</a>
                                                    {/* <a href="javascript:void(0)" className={`list-group-item list-group-item-action ${activeCurrencyItem === 'DOGE' ? 'active' : ''}`} onClick={() => { handleCurrencyItemClick('DOGE') }}>DOGE </a> */}
                                                    {/* <a href="javascript:void(0)" className={`list-group-item list-group-item-action ${activeCurrencyItem === 'BTC' ? 'active' : ''}`} onClick={() => { handleCurrencyItemClick('BTC') }}>BTC </a> */}
                                                </div>
                                            </div>}
                                        </div>


                                    </div>
                                </div>
                                <div className="filter-price-left">
                                    <div className="title-left">
                                        <h3>Price</h3>
                                    </div>
                                    <div className="price-box-slider">
                                        {/* <select className="form-control">
                                            <option value="">Select Currency</option> */}
                                        {/* <option value="1">BTC</option> */}
                                        {/* <option value="2">ETH</option> */}
                                        {/* <option value="3">DOGE</option> */}
                                        {/* </select> */}
                                        <div className="row mt-2 ml-2 mr-2">
                                            <input type="text" className="form-control col-md-4" placeholder="Min" id="priceFilterMin" />
                                            <span className="col-md-4">-</span>
                                            <input type="text" className="form-control col-md-4" placeholder="Max" id="priceFilterMax" />
                                        </div>
                                        <p>

                                            <button className="btn hvr-hover" type="submit" style={{ width: '100%' }} onClick={() => {
                                                handlePriceFilter()
                                            }}>Filter</button>
                                            {isPriceFilterInitiated && <a className="btn reset-btn" onClick={() => {
                                                setFromValue(0)
                                                setToValue(0)
                                                setPriceFilterIntiated(false)
                                                document.getElementById('priceFilterMin').value = '';
                                                document.getElementById('priceFilterMax').value = '';
                                                renderNftsByCollection(props.match.params.id, props.match.params.name);
                                            }}>Reset</a>}
                                        </p>
                                    </div>
                                </div>
                                {getAllSessionData() != undefined && getAllSessionData() != null && getAllSessionData().account != undefined && getAllSessionData().account != null && userCollDetails.creator != undefined && userCollDetails.creator != null && userCollDetails.creator.toLowerCase() != getAllSessionData().account.toLowerCase() && <div className="filter-price-left">
                                    <div className="title-left">
                                        <h3>Floor Bid</h3>
                                    </div>
                                    {userCollDetails.floorBid.bidder.toLowerCase() !== getAllSessionData().account.toLowerCase() ? <div className="price-box-slider">

                                        <div className="row mt-2 ml-2 mr-2">
                                            <input type="text" className="form-control col-md-12" placeholder="Amount" onChange={(e) => {
                                                //console.log(lowestFloorPrice)
                                                if (lowestFloorPrice != null) {
                                                    //console.log(parseFloat(e.target.value), parseFloat(web3.utils.fromWei(lowestFloorPrice.toString(), 'ether')), parseFloat(web3.utils.fromWei(lowestFloorPrice.toString(), 'ether')) * 0.75)
                                                    if (parseFloat(e.target.value) >= parseFloat(web3.utils.fromWei(lowestFloorPrice.toString(), 'ether')) * 0.75) {
                                                        setFloorBidAmount(e.target.value)
                                                        setIsValidForPlacingBid(true)
                                                    } else {
                                                        setIsValidForPlacingBid(false)
                                                        showToast('error', 'Bid amount should be greater than 75% of floor price')
                                                    }
                                                } else {
                                                    if (parseFloat(e.target.value) >= 0.0001) {
                                                        setFloorBidAmount(e.target.value)
                                                        setIsValidForPlacingBid(true)
                                                    } else {
                                                        setIsValidForPlacingBid(false)
                                                        showToast('error', 'Bid amount should be greater than or equals to 0.0001')
                                                    }

                                                }
                                            }} />

                                        </div>
                                        <div className="row mt-2 ml-2 mr-2">
                                            <div className="col-md-12">
                                                <DateTimePicker onChange={(date) => { handleExpiredValue(date) }} value={floorBidExpires} style={{ width: '100%' }} />
                                            </div>
                                        </div>
                                        <p>

                                            <button className="btn hvr-hover" type="submit" style={{ width: '100%' }} onClick={() => { placeFloorBid() }} disabled={!isValidForPlacingBid}>Add Floor Bid</button>
                                        </p>
                                    </div> : <div className="price-box-slider">

                                        {userCollDetails.floorBid.isExpired == false ? <p>Your bid will expires on {new Date(userCollDetails.floorBid.expirationTime.toString() * 1000).toLocaleString()} </p> : <p>Your bid has expired on {new Date(userCollDetails.floorBid.expirationTime.toString() * 1000).toLocaleString()}</p>}

                                        <p>

                                            <button className="btn hvr-hover" type="submit" style={{ width: '100%' }} onClick={() => { withdrawFloorBid() }}>Withdraw Floor Bid</button>
                                        </p>
                                    </div>}
                                </div>}
                                {/* <div className="filter-price-left">
                                    <div className="title-left">
                                        <h3>Rarity</h3>
                                    </div>
                                    <div className="price-box-slider">
                                        <div className="row mt-2 ml-2 mr-2">
                                            <input type="text" className="form-control col-md-4" placeholder="1" />
                                            <span className="col-md-4">-</span>
                                            <input type="text" className="form-control col-md-4" placeholder="6,571" />
                                        </div>
                                        <p>

                                            <button className="btn hvr-hover" type="submit" style={{ width: '100%' }}>Filter</button>
                                        </p>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>}
                    {/* Offer section */}
                    {isDisplayTab == 'offers' && <div className="row mt-3">
                        <div className="col-xl-12 col-lg-12 col-sm-12 col-xs-12 shop-content-right">
                            <div className="right-product-box">
                                <div className="product-item-filter row">
                                    <div className="col-2 col-sm-2 text-center text-sm-left">
                                        <span>{totalOffers} Offers</span>
                                    </div>
                                    <div className="col-2 col-sm-2 text-center text-sm-left">

                                    </div>
                                    <div className="col-8 col-sm-8 text-center text-sm-left">
                                        <span>
                                            {/* <span className="ml-2">Volume : 343 ETH</span> */}
                                            <span className="ml-2">Total Floor : {lowestFloorPrice != null ? web3.utils.fromWei(lowestFloorPrice.toString(), 'ether') : '-'} ETH</span>
                                            {/* <span className="ml-2">Best Offer : {bestOffer} ETH</span> */}
                                            {/* <span className="ml-2">Total Offer Volume : 343 ETH</span> */}
                                        </span>
                                    </div>

                                </div>

                                <div className="product-categorie-box">
                                    <div className="tab-content">
                                        <table className="table table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="20%">Asset</th>
                                                    <th scope="col" width="50%">Offer Price</th>
                                                    {/* <th scope="col" width="20%">Offer Start Date</th>*/}
                                                    <th scope="col" width="20%">Expired On</th>
                                                    <th scope="col" width="30%">Bidders</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {offers.map((offer) => (
                                                    offer.offerer != '0x0000000000000000000000000000000000000000' && <tr style={{ cursor: 'pointer' }}>
                                                        <td scope="row" width="20%">{offer.asset}</td>
                                                        <td scope="row" width="50%">
                                                            <div className="progress-bar" role="progressbar" style={{ width: '45%' }} aria-valuenow="45" aria-valuemin="0" aria-valuemax="100">{offer.offerAmount > 0 ? web3.utils.fromWei(offer.offerAmount.toString(), 'ether') : parseFloat(offer.offerAmount)} ETH</div>
                                                        </td>
                                                        {/* <td width="20%">{offer.startDate}</td>*/}
                                                        <td width="20%">{moment(offer.offerExpiration.toString() * 1000).format('YYYY-MM-DD hh:mm:ss')}</td>
                                                        <td width="30%">{offer.offerer}</td>
                                                    </tr>
                                                ))}


                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-xl-3 col-lg-3 col-sm-12 col-xs-12 sidebar-shop-left">
                            <div className="product-categori">
                                <div className="search-product">
                                    <form action="#">
                                        <input className="form-control" placeholder="Search here..." type="text" />
                                        <button type="submit"> <i className="fa fa-search"></i> </button>
                                    </form>
                                </div>
                                <div className="filter-sidebar-left">
                                    <div className="title-left">
                                        <h3>Traits</h3>
                                    </div>
                                    <div className="list-group list-group-collapse list-group-sm list-group-tree" id="list-group-men" data-children=".sub-men">
                                        <div className="list-group-collapse sub-men">
                                            <a onClick={() => { setStatusCategory(!showStatusCategory) }} className="list-group-item list-group-item-action" href="javascript:void(0)" >New traits <small className="text-muted">0.007 ETH</small>
                                            </a>

                                        </div>



                                    </div>
                                </div>
                                <div className="filter-price-left">
                                    <div className="title-left">
                                        <h3>Price</h3>
                                    </div>
                                    <div className="price-box-slider">
                                        <select className="form-control">
                                            <option value="">Select Currency</option>
                                            <option value="1">BTC</option>
                                            <option value="2">ETH</option>
                                            <option value="3">DOGE</option>
                                        </select>
                                        <div className="row mt-2 ml-2 mr-2">
                                            <input type="text" className="form-control col-md-4" placeholder="Min" />
                                            <span className="col-md-4">-</span>
                                            <input type="text" className="form-control col-md-4" placeholder="Max" />
                                        </div>
                                        <p>

                                            <button className="btn hvr-hover" type="submit" style={{ width: '100%' }}>Filter</button>
                                        </p>
                                    </div>
                                </div>
                                <div className="filter-price-left">
                                    <div className="title-left">
                                        <h3>Rarity</h3>
                                    </div>
                                    <div className="price-box-slider">
                                        <div className="row mt-2 ml-2 mr-2">
                                            <input type="text" className="form-control col-md-4" placeholder="1" />
                                            <span className="col-md-4">-</span>
                                            <input type="text" className="form-control col-md-4" placeholder="6,571" />
                                        </div>
                                        <p>

                                            <button className="btn hvr-hover" type="submit" style={{ width: '100%' }}>Filter</button>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>}
                    {/* Analytics section */}
                    {isDisplayTab == 'analytics' && <div className="row mt-3">
                        <div className="col-xl-9 col-lg-9 col-sm-12 col-xs-12 shop-content-right">
                            <div className="right-product-box">
                                <div className="product-item-filter row">
                                    <div className="col-12 col-sm-8 text-center text-sm-left">
                                        <div className="toolbar-sorter-right">
                                            {/*  <span>Sort by </span> */}
                                            <select id="basic" className="form-control" data-placeholder="$ USD" style={{ display: 'block' }}>
                                                <option value="1">Last 7 days</option>
                                                <option value="2">Last 8 hours</option>
                                                <option value="3">Last 24 hours</option>
                                                <option value="4">First Sale date</option>
                                            </select>
                                        </div>
                                        {/*  <p>Showing all 4 results</p> */}
                                    </div>
                                    <div className="col-12 col-sm-4 text-center text-sm-right">
                                        {/*  <ul className="nav nav-tabs ml-auto">
                                    <li>
                                        <a className="nav-link active" href="#grid-view" data-toggle="tab"> <i className="fa fa-th"></i> </a>
                                    </li>
                                    <li>
                                        <a className="nav-link" href="#list-view" data-toggle="tab"> <i className="fa fa-list-ul"></i> </a>
                                    </li>
                                </ul> */}
                                    </div>
                                </div>

                                <div className="product-categorie-box">
                                    <div className="tab-content">
                                        <div role="tabpanel" className="tab-pane fade show active" id="grid-view">
                                            <div className="row">
                                                <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                                    <div className="products-single fix chunk">
                                                        <div>
                                                            <span>Volume</span>
                                                        </div>
                                                        <div>
                                                            <h3>27.43 ETH</h3>
                                                        </div>
                                                        <div>
                                                            <span style={{ color: 'red' }}>-88%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                                    <div className="products-single fix chunk">
                                                        <div>
                                                            <span>Sales</span>
                                                        </div>
                                                        <div>
                                                            <h3>213</h3>
                                                        </div>
                                                        <div>
                                                            <span style={{ color: 'red' }}>-82%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                                    <div className="products-single fix chunk">
                                                        <div>
                                                            <span>Floor Price</span>
                                                        </div>
                                                        <div>
                                                            <h3>0.09 ETH</h3>
                                                        </div>
                                                        <div>
                                                            <span style={{ color: 'red' }}>-88%</span>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <Bar options={volumePriceOptions} data={volumePriceData} />
                                                </div>
                                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div className="products-single fix chunk">
                                                        <Line options={floorPriceOptions} data={floorPriceData} />
                                                    </div>
                                                </div>


                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div className="products-single fix chunk">
                                                        <div className="row mb-1 mt-2 ml-2">

                                                            <h3 classname="col-md-4">Listing</h3>
                                                            <span className="col-md-4"></span>
                                                            <select className="col-md-4 form-control">
                                                                <option>Price</option>
                                                                <option>Sale</option>
                                                            </select>
                                                        </div>
                                                        <div className="">
                                                            <table className="table table-hover">

                                                                <tbody>
                                                                    <tr className="listing-row" style={{ cursor: 'pointer' }}>
                                                                        <td scope="row" width="60%">
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <img src={require('../assets/images/images2.jfif')} className="" width="60px" alt="Image" />
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <h4>Gruffer</h4>
                                                                                    <span>7 hours ago</span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td width="20%" className="value">
                                                                            <h4>0.092 ETH</h4>
                                                                            <span>-3% Floor</span>
                                                                        </td>
                                                                        <td width="20%" className="buy-btn"><button className="btn btn-primary">Buy Now</button></td>
                                                                    </tr>
                                                                    <tr className="listing-row" style={{ cursor: 'pointer' }}>
                                                                        <td scope="row" width="60%">
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <img src={require('../assets/images/images2.jfif')} className="" width="60px" alt="Image" />
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <h4>Gruffer</h4>
                                                                                    <span>7 hours ago</span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td width="20%" className="value">
                                                                            <h4>0.092 ETH</h4>
                                                                            <span>-3% Floor</span>
                                                                        </td>
                                                                        <td width="20%" className="buy-btn"><button className="btn btn-primary">Buy Now</button></td>
                                                                    </tr>
                                                                    <tr className="listing-row" style={{ cursor: 'pointer' }}>
                                                                        <td scope="row" width="60%">
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <img src={require('../assets/images/images2.jfif')} className="" width="60px" alt="Image" />
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <h4>Gruffer</h4>
                                                                                    <span>7 hours ago</span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td width="20%" className="value">
                                                                            <h4>0.092 ETH</h4>
                                                                            <span>-3% Floor</span>
                                                                        </td>
                                                                        <td width="20%" className="buy-btn"><button className="btn btn-primary">Buy Now</button></td>
                                                                    </tr>


                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div className="products-single fix chunk">
                                                        <Line options={floorPriceOptions} data={floorPriceData} />
                                                    </div>
                                                </div>


                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div className="products-single fix chunk">
                                                        <div className="row mb-1 mt-2 ml-2">

                                                            <h3 classname="col-md-4">Sales</h3>
                                                            <span className="col-md-4"></span>
                                                            <select className="col-md-4 form-control">
                                                                <option>Price</option>
                                                                <option>Sale</option>
                                                            </select>
                                                        </div>
                                                        <div className="fixed-area-table">
                                                            <table className="table table-hover">

                                                                <tbody>
                                                                    <tr className="" style={{ cursor: 'pointer' }}>
                                                                        <td scope="row" width="60%">
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <img src={require('../assets/images/images2.jfif')} className="" width="60px" alt="Image" />
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <h4>Gruffer</h4>
                                                                                    <span>7 hours ago</span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td width="20%" className="">
                                                                            <h4>0.092 ETH</h4>
                                                                            <span>-3% Floor</span>
                                                                        </td>

                                                                    </tr>
                                                                    <tr className="" style={{ cursor: 'pointer' }}>
                                                                        <td scope="row" width="60%">
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <img src={require('../assets/images/images2.jfif')} className="" width="60px" alt="Image" />
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <h4>Gruffer</h4>
                                                                                    <span>7 hours ago</span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td width="20%" className="">
                                                                            <h4>0.092 ETH</h4>
                                                                            <span>-3% Floor</span>
                                                                        </td>

                                                                    </tr>
                                                                    <tr className="" style={{ cursor: 'pointer' }}>
                                                                        <td scope="row" width="60%">
                                                                            <div className="row">
                                                                                <div className="col-md-6">
                                                                                    <img src={require('../assets/images/images2.jfif')} className="" width="60px" alt="Image" />
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <h4>Gruffer</h4>
                                                                                    <span>7 hours ago</span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td width="20%" className="">
                                                                            <h4>0.092 ETH</h4>
                                                                            <span>-3% Floor</span>
                                                                        </td>

                                                                    </tr>



                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                    <div className="products-single fix chunk">
                                                        <Bar options={floorPriceOptions} data={floorPriceData} />
                                                    </div>
                                                </div>


                                            </div>

                                        </div>
                                        <div role="tabpanel" className="tab-pane fade" id="list-view">
                                            <div className="list-view-box">
                                                <div className="row">
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                                        <div className="products-single fix">
                                                            <div className="box-img-hover">
                                                                <div className="type-lb">
                                                                    <p className="new">New</p>
                                                                </div>
                                                                <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                                                                <div className="mask-icon">
                                                                    <ul>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="Compare"><i className="fas fa-sync-alt"></i></a></li>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li>
                                                                    </ul>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-md-6 col-lg-8 col-xl-8">
                                                        <div className="why-text full-width">
                                                            <h4>Lorem ipsum dolor sit amet</h4>
                                                            <h5> <del>$ 60.00</del> $40.79</h5>
                                                            <p>Integer tincidunt aliquet nibh vitae dictum. In turpis sapien, imperdiet quis magna nec, iaculis ultrices ante. Integer vitae suscipit nisi. Morbi dignissim risus sit amet orci porta, eget aliquam purus
                                                                sollicitudin. Cras eu metus felis. Sed arcu arcu, sagittis in blandit eu, imperdiet sit amet eros. Donec accumsan nisi purus, quis euismod ex volutpat in. Vestibulum eleifend eros ac lobortis aliquet.
                                                                Suspendisse at ipsum vel lacus vehicula blandit et sollicitudin quam. Praesent vulputate semper libero pulvinar consequat. Etiam ut placerat lectus.</p>
                                                            <a className="btn hvr-hover" href="#">Add to Cart</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="list-view-box">
                                                <div className="row">
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                                        <div className="products-single fix">
                                                            <div className="box-img-hover">
                                                                <div className="type-lb">
                                                                    <p className="sale">Sale</p>
                                                                </div>
                                                                <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                                                                <div className="mask-icon">
                                                                    <ul>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="Compare"><i className="fas fa-sync-alt"></i></a></li>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li>
                                                                    </ul>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-md-6 col-lg-8 col-xl-8">
                                                        <div className="why-text full-width">
                                                            <h4>Lorem ipsum dolor sit amet</h4>
                                                            <h5> <del>$ 60.00</del> $40.79</h5>
                                                            <p>Integer tincidunt aliquet nibh vitae dictum. In turpis sapien, imperdiet quis magna nec, iaculis ultrices ante. Integer vitae suscipit nisi. Morbi dignissim risus sit amet orci porta, eget aliquam purus
                                                                sollicitudin. Cras eu metus felis. Sed arcu arcu, sagittis in blandit eu, imperdiet sit amet eros. Donec accumsan nisi purus, quis euismod ex volutpat in. Vestibulum eleifend eros ac lobortis aliquet.
                                                                Suspendisse at ipsum vel lacus vehicula blandit et sollicitudin quam. Praesent vulputate semper libero pulvinar consequat. Etiam ut placerat lectus.</p>
                                                            <a className="btn hvr-hover" href="#">Add to Cart</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="list-view-box">
                                                <div className="row">
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                                        <div className="products-single fix">
                                                            <div className="box-img-hover">
                                                                <div className="type-lb">
                                                                    <p className="sale">Sale</p>
                                                                </div>
                                                                <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                                                                <div className="mask-icon">
                                                                    <ul>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="Compare"><i className="fas fa-sync-alt"></i></a></li>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li>
                                                                    </ul>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-md-6 col-lg-8 col-xl-8">
                                                        <div className="why-text full-width">
                                                            <h4>Lorem ipsum dolor sit amet</h4>
                                                            <h5> <del>$ 60.00</del> $40.79</h5>
                                                            <p>Integer tincidunt aliquet nibh vitae dictum. In turpis sapien, imperdiet quis magna nec, iaculis ultrices ante. Integer vitae suscipit nisi. Morbi dignissim risus sit amet orci porta, eget aliquam purus
                                                                sollicitudin. Cras eu metus felis. Sed arcu arcu, sagittis in blandit eu, imperdiet sit amet eros. Donec accumsan nisi purus, quis euismod ex volutpat in. Vestibulum eleifend eros ac lobortis aliquet.
                                                                Suspendisse at ipsum vel lacus vehicula blandit et sollicitudin quam. Praesent vulputate semper libero pulvinar consequat. Etiam ut placerat lectus.</p>
                                                            <a className="btn hvr-hover" href="#">Add to Cart</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-sm-12 col-xs-12 sidebar-shop-left">
                            <div className="product-categori">
                                <div className="search-product">
                                    <form action="#">
                                        <input className="form-control" placeholder="Search here..." type="text" />
                                        <button type="submit"> <i className="fa fa-search"></i> </button>
                                    </form>
                                </div>
                                <div className="filter-sidebar-left">
                                    <div className="title-left">
                                        {/* <h3>Categories</h3> */}
                                    </div>
                                    <div className="list-group list-group-collapse list-group-sm list-group-tree" id="list-group-men" data-children=".sub-men">
                                        <div className="list-group-collapse sub-men">
                                            <a onClick={() => { setStatusCategory(!showStatusCategory) }} className="list-group-item list-group-item-action" href="javascript:void(0)" >Asset Type <small className="text-muted">(100)</small><i className={`ml-2 fa + ${showStatusCategory ? 'fa-caret-up' : 'fa-caret-down'}`} aria-hidden="true"></i>
                                            </a>
                                            {showStatusCategory && <div className="collapse show" id="sub-men1" data-parent="#list-group-men">
                                                <div className="list-group">
                                                    <a href="#" className="list-group-item list-group-item-action active">All<small className="text-muted">(50)</small></a>
                                                    <a href="#" className="list-group-item list-group-item-action">Listed <small className="text-muted">(10)</small></a>
                                                    <a href="#" className="list-group-item list-group-item-action">New <small className="text-muted">(10)</small></a>
                                                    <a href="#" className="list-group-item list-group-item-action">Has offer <small className="text-muted">(10)</small></a>

                                                </div>
                                            </div>}
                                        </div>
                                        <div className="list-group-collapse sub-men">
                                            <a onClick={() => { setCurrencyCategory(!showCurrencyCategory) }} className="list-group-item list-group-item-action" href="javascript:void(0)" >Currency <small className="text-muted">(3)</small><i className={`ml-2 fa + ${showCurrencyCategory ? 'fa-caret-up' : 'fa-caret-down'}`} aria-hidden="true"></i>
                                            </a>
                                            {showCurrencyCategory && <div className="collapse show" id="sub-men1" data-parent="#list-group-men">
                                                <div className="list-group">
                                                    <a href="#" className="list-group-item list-group-item-action active">ETH</a>
                                                    <a href="#" className="list-group-item list-group-item-action">DOGE </a>
                                                    <a href="#" className="list-group-item list-group-item-action">BTC </a>
                                                </div>
                                            </div>}
                                        </div>


                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>}
                    {isDisplayTab == 'activity' && <div className="row mt-3">
                        <div className="col-xl-9 col-lg-9 col-sm-12 col-xs-12 shop-content-right">
                            <div className="right-product-box">
                                <div className="product-item-filter row">

                                    <div className="col-12 col-sm-4 text-center text-sm-right">
                                        {/*  <ul className="nav nav-tabs ml-auto">
                                    <li>
                                        <a className="nav-link active" href="#grid-view" data-toggle="tab"> <i className="fa fa-th"></i> </a>
                                    </li>
                                    <li>
                                        <a className="nav-link" href="#list-view" data-toggle="tab"> <i className="fa fa-list-ul"></i> </a>
                                    </li>
                                </ul> */}
                                    </div>
                                </div>

                                <div className="product-categorie-box">
                                    <div className="tab-content">
                                        <div role="tabpanel" className="tab-pane fade show active" id="grid-view">


                                            <div className="row">
                                                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                                    <div className="products-single fix chunk">

                                                        <div className="fixed-area-table">
                                                            <table className="table table-hover">
                                                                <thead>
                                                                    <th>Event</th>
                                                                    <th>Price</th>
                                                                    <th>From</th>
                                                                    <th>To</th>
                                                                    <th>Time</th>
                                                                </thead>
                                                                <tbody>
                                                                    {activities.map((activity) => (
                                                                        <tr className="" style={{ cursor: 'pointer' }}>
                                                                            <td>{activity.eventName}</td>
                                                                            <td width="20%" className="">
                                                                                <h4>{activity.eventPrice} ETH</h4>
                                                                            </td>
                                                                            <td>{activity.fromUserName != null ? activity.fromUserName : activity.fromUserUuid}</td>
                                                                            <td>{activity.toUserName != null ? activity.toUserName : activity.toUserUuid}</td>
                                                                            <td>{activity.createdOn}</td>
                                                                        </tr>
                                                                    ))}





                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>



                                            </div>

                                        </div>
                                        <div role="tabpanel" className="tab-pane fade" id="list-view">
                                            <div className="list-view-box">
                                                <div className="row">
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                                        <div className="products-single fix">
                                                            <div className="box-img-hover">
                                                                <div className="type-lb">
                                                                    <p className="new">New</p>
                                                                </div>
                                                                <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                                                                <div className="mask-icon">
                                                                    <ul>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="Compare"><i className="fas fa-sync-alt"></i></a></li>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li>
                                                                    </ul>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-md-6 col-lg-8 col-xl-8">
                                                        <div className="why-text full-width">
                                                            <h4>Lorem ipsum dolor sit amet</h4>
                                                            <h5> <del>$ 60.00</del> $40.79</h5>
                                                            <p>Integer tincidunt aliquet nibh vitae dictum. In turpis sapien, imperdiet quis magna nec, iaculis ultrices ante. Integer vitae suscipit nisi. Morbi dignissim risus sit amet orci porta, eget aliquam purus
                                                                sollicitudin. Cras eu metus felis. Sed arcu arcu, sagittis in blandit eu, imperdiet sit amet eros. Donec accumsan nisi purus, quis euismod ex volutpat in. Vestibulum eleifend eros ac lobortis aliquet.
                                                                Suspendisse at ipsum vel lacus vehicula blandit et sollicitudin quam. Praesent vulputate semper libero pulvinar consequat. Etiam ut placerat lectus.</p>
                                                            <a className="btn hvr-hover" href="#">Add to Cart</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="list-view-box">
                                                <div className="row">
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                                        <div className="products-single fix">
                                                            <div className="box-img-hover">
                                                                <div className="type-lb">
                                                                    <p className="sale">Sale</p>
                                                                </div>
                                                                <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                                                                <div className="mask-icon">
                                                                    <ul>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="Compare"><i className="fas fa-sync-alt"></i></a></li>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li>
                                                                    </ul>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-md-6 col-lg-8 col-xl-8">
                                                        <div className="why-text full-width">
                                                            <h4>Lorem ipsum dolor sit amet</h4>
                                                            <h5> <del>$ 60.00</del> $40.79</h5>
                                                            <p>Integer tincidunt aliquet nibh vitae dictum. In turpis sapien, imperdiet quis magna nec, iaculis ultrices ante. Integer vitae suscipit nisi. Morbi dignissim risus sit amet orci porta, eget aliquam purus
                                                                sollicitudin. Cras eu metus felis. Sed arcu arcu, sagittis in blandit eu, imperdiet sit amet eros. Donec accumsan nisi purus, quis euismod ex volutpat in. Vestibulum eleifend eros ac lobortis aliquet.
                                                                Suspendisse at ipsum vel lacus vehicula blandit et sollicitudin quam. Praesent vulputate semper libero pulvinar consequat. Etiam ut placerat lectus.</p>
                                                            <a className="btn hvr-hover" href="#">Add to Cart</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="list-view-box">
                                                <div className="row">
                                                    <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                                        <div className="products-single fix">
                                                            <div className="box-img-hover">
                                                                <div className="type-lb">
                                                                    <p className="sale">Sale</p>
                                                                </div>
                                                                <img src={require('../assets/images/images2.jfif')} className="img-fluid" alt="Image" />
                                                                <div className="mask-icon">
                                                                    <ul>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="View"><i className="fas fa-eye"></i></a></li>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="Compare"><i className="fas fa-sync-alt"></i></a></li>
                                                                        <li><a href="#" data-toggle="tooltip" data-placement="right" title="Add to Favorites"><i className="far fa-heart"></i></a></li>
                                                                    </ul>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-6 col-md-6 col-lg-8 col-xl-8">
                                                        <div className="why-text full-width">
                                                            <h4>Lorem ipsum dolor sit amet</h4>
                                                            <h5> <del>$ 60.00</del> $40.79</h5>
                                                            <p>Integer tincidunt aliquet nibh vitae dictum. In turpis sapien, imperdiet quis magna nec, iaculis ultrices ante. Integer vitae suscipit nisi. Morbi dignissim risus sit amet orci porta, eget aliquam purus
                                                                sollicitudin. Cras eu metus felis. Sed arcu arcu, sagittis in blandit eu, imperdiet sit amet eros. Donec accumsan nisi purus, quis euismod ex volutpat in. Vestibulum eleifend eros ac lobortis aliquet.
                                                                Suspendisse at ipsum vel lacus vehicula blandit et sollicitudin quam. Praesent vulputate semper libero pulvinar consequat. Etiam ut placerat lectus.</p>
                                                            <a className="btn hvr-hover" href="#">Add to Cart</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-sm-12 col-xs-12 sidebar-shop-left">
                            <div className="product-categori">

                                <div className="filter-sidebar-left">
                                    <div className="title-left">
                                        {/* <h3>Categories</h3> */}
                                    </div>
                                    <div className="list-group list-group-collapse list-group-sm list-group-tree" id="list-group-men" data-children=".sub-men">
                                        <div className="list-group-collapse sub-men">
                                            <a onClick={() => { setStatusCategory(!showStatusCategory) }} className="list-group-item list-group-item-action" href="javascript:void(0)" >Event Type <i className={`ml-2 fa + ${showStatusCategory ? 'fa-caret-up' : 'fa-caret-down'}`} aria-hidden="true"></i>
                                            </a>
                                            {showStatusCategory && <div className="collapse show" id="sub-men1" data-parent="#list-group-men">
                                                <div className="list-group">
                                                    <a href="javascript:void(0)" className="list-group-item list-group-item-action active" onClick={() => {
                                                        getCollectionActivity(props.match.params.id, 'ALL')
                                                    }}>All</a>
                                                    <a href="javascript:void(0)" className="list-group-item list-group-item-action" onClick={() => {
                                                        getCollectionActivity(props.match.params.id, 'SALE')
                                                    }}>Sale</a>
                                                    <a href="javascript:void(0)" className="list-group-item list-group-item-action" onClick={() => {
                                                        getCollectionActivity(props.match.params.id, 'OFFERS')
                                                    }}>Offers</a>
                                                    <a href="javascript:void(0)" className="list-group-item list-group-item-action" onClick={() => {
                                                        getCollectionActivity(props.match.params.id, 'TRANSFER')
                                                    }}>Transfer</a>

                                                </div>
                                            </div>}
                                        </div>



                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>}
                </div>
            </div>

            <Fragment>
                <div className={"modal  " + (showEditCollModal ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showEditCollModal ? 'block' : 'none', paddingRight: '17px', background: '#0000008c', overflow: 'scroll' }}>
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">Edit Collection</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setShowEditCollModal(false) }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div className="form-group">
                                            <label>Logo Image *</label>
                                            <small> (File size should not be exceeded more than 25MB.)</small>
                                            <input type="file" className="form-control" onChange={(e) => {
                                                let selectedFile = e.target.files[0];
                                                console.log('FILE', selectedFile);
                                                if (selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/jpg' || selectedFile.type === 'image/png') {
                                                    if (selectedFile.size <= 25 * 1024 * 1024) {
                                                        setUpdateBtn(false)
                                                        setCollectionLogo(e.target.files[0])
                                                    } else {
                                                        showToast('error', 'File size should not be exceeded more than 25MB.')
                                                        setUpdateBtn(true)
                                                    }

                                                } else {
                                                    setUpdateBtn(true)
                                                    showToast('error', 'Please select valid file')
                                                }
                                            }} />
                                            <small>Upload only jpeg, jpg and png file type.</small>
                                            <p>{editCollectionLogo}</p>
                                        </div>
                                        <div className="form-group">
                                            <label>Cover Image *</label>
                                            <small> (File size should not be exceeded more than 25MB.)</small>
                                            <input type="file" className="form-control" onChange={(e) => {
                                                let selectedFile = e.target.files[0];
                                                if (selectedFile.type === 'image/jpeg' || selectedFile.type === 'image/jpg' || selectedFile.type === 'image/png') {
                                                    if (selectedFile.size <= 25 * 1024 * 1024) {
                                                        setCollectionBanner(e.target.files[0])
                                                        setUpdateBtn(false)
                                                    } else {

                                                        showToast('error', 'File size should not be exceeded more than 25MB.')
                                                        setUpdateBtn(true)
                                                    }

                                                } else {
                                                    setUpdateBtn(true)
                                                    showToast('error', 'Please select valid file')
                                                }
                                            }} />
                                            <small>Upload only jpeg, jpg and png file type.</small>
                                            <p>{editCollectionBanner}</p>
                                        </div>
                                        {/* <div className="form-group">
                                            <label>Name *</label>
                                            <input type="text" className="form-control" value={editCollectionName} onChange={(e) => {
                                                setEditCollectionName(e.target.value)
                                            }} />
                                        </div> */}
                                        {/* <div className="form-group">
                                            <label>Symbol *</label>
                                            <input type="text" className="form-control" value={editCollectionSymbol} onChange={(e) => {
                                                setEditCollectionSymbol(e.target.value)
                                            }} />
                                        </div> */}
                                        <div className="form-group">
                                            <label>Description *</label>
                                            <textarea className="form-control" value={editCollectionDescription} onChange={(e) => {
                                                setEditCollectionDescription(e.target.value)
                                            }}></textarea>
                                        </div>
                                        <div className="form-group">
                                            <label>Twitter</label>
                                            <input type="text" className="form-control" value={editTwitterLink} onChange={(e) => {
                                                setEditTwitterLink(e.target.value)
                                            }} />
                                        </div>
                                        {/* <div className="form-group">
                                            <label>Category *</label>
                                            <select className="form-control" onChange={(e) => {
                                                setCollectionCategorySelected(e.target.value)
                                            }}>
                                                <option value="">Select Category</option>
                                                {collectionCategories.map((cat) => (
                                                    <option value={cat.nftCollectionCategoryId} key={cat.nftCollectionCategoryId}>{cat.categoryName}</option>
                                                ))}
                                            </select>
                                        </div> */}


                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">


                                        <div className="form-group">
                                            <label>Facebook</label>
                                            <input type="text" className="form-control" value={editFacebookLink} onChange={(e) => {
                                                setEditFacebookLink(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Instagram</label>
                                            <input type="text" className="form-control" value={editInstagramLink} onChange={(e) => {
                                                setEditInstagramLink(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Discord</label>
                                            <input type="text" className="form-control" value={editDiscordLink} onChange={(e) => {
                                                setEditDiscordLink(e.target.value)
                                            }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Telegram</label>
                                            <input type="text" className="form-control" value={editTelegramLink} onChange={(e) => {
                                                setEditTelegramLink(e.target.value)
                                            }} />
                                        </div>


                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <button className="btn btn-primary" disabled={updateBtn} onClick={() => { updateCollection() }}>Save</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>

            <Fragment>
                <div className={"modal " + (showFloorBidPopup ? 'show' : '')} tabIndex="-1" role="dialog" style={{ display: showFloorBidPopup ? 'block' : 'none', paddingRight: '17px', background: '#0000008c' }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h3 className="modal-title">Floor Bid</h3>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { setFloorBidPopup(false); }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row" style={{ padding: '4px 7px 4px 11px' }}>




                                </div>




                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
            <Footer />
            <Loader show={showLoader} />
        </Fragment>
    );
}

export default UserCollections;